<template>

  <template v-if="text || secondary">
    <n-button :class="{
      [variant]: true,
      secondary,
      squared,
      compact,
       text,
      disabled,
    }" role="button" :disabled="disabled" :loading="loading" :size="size" :variant="variant" :secondary="secondary"
      :text="text">
      <template #icon>
        <slot name="icon"></slot>
      </template>
      <slot></slot>
    </n-button>
  </template>
  <template v-else>
    <button class="z-button" :class="{
      [variant]: true,
      [size]: true,
      squared,
      padded,
      compact,
      disabled,
      }" :disabled="disabled">
      <slot name="icon"></slot>
      <template v-if="loading">
        <template v-if="variant=='default'">Chargement...</template>
        <div v-else class="relative inline-flex invisible">
          <slot></slot>
          <div class="loader line-of-dots visible"></div>
        </div>
      </template>
      <template v-else>
        <slot></slot>
      </template>
    </button>
  </template>
</template>

<script setup lang="ts">
import { PropType } from "vue";
import {NButton} from "naive-ui"

defineProps({
  disabled: Boolean,
  loading: Boolean,
  squared: Boolean,
  secondary: Boolean,
  text: Boolean,
  padded: Boolean,
  compact: Boolean,
  size: { type: String as PropType<"tiny" | "small" | "medium" | "large">, default: "medium" },
  variant: { type: String as PropType<"default" | "secondary" | "primary" | "info" | "success" | "warning" | "error" |"custom">, default: "primary" },
});
</script>

<style lang="postcss" scoped>
.z-button {

  @apply inline-flex gap-1;
  @apply justify-center items-center;
  @apply duration-300;

  &.squared {
    @apply rounded-md;
  }

  &:not(.squared) {
    @apply rounded-2xl;
  }

  &.medium,
  &.large {
    @apply p-4;
    line-height: 1rem;
  }

  &.large {
    @apply text-xl;
    line-height: 1.25rem;
  }

  &.small {
    @apply text-sm;
    line-height: 0.825rem;
    @apply px-2 py-2;
  }

  &.tiny {
    @apply text-xs;
    @apply px-1 py-1;
  }

  &.custom {
    color: inherit;
    background-color: inherit;
  }

  &.default {
    @apply text-[#003F5C] font-medium;
  }
  &.primary {
    @apply bg-primary text-blue-100 hover:bg-[#003F5CCC];
  }

  &.secondary {
    @apply bg-[#003F5C29] text-[#003F5C] hover:bg-[#1479FF1A];
  }

  &.info {
    @apply bg-[#59678029] text-[#596780] hover:bg-[#5967801A];
  }

  &.success {
    @apply bg-success text-white hover:bg-[#FFA600AA];
  }

  &.disabled {
    @apply opacity-50 cursor-not-allowed disabled:cursor-not-allowed disabled:opacity-50;
  }

  &.padded {
    @apply px-7;
  }

  &.compact {
    padding-top: 0.7rem;
    padding-bottom: 0.7rem;
  }
}

.loader {
  @apply absolute top-1 left-0 right-0 bottom-0 flex content-center justify-center;
}
</style>

